import { LanguageTypes } from '@compliance/types'
import {
  getLanguageNamespaces,
  getLanguageOptions,
} from '@caudena/core/constants'

export const DEFAULT_LANG = 'en'

export const LANG_NAMESPACES = getLanguageNamespaces(['compliance'])
export const LANG_STORAGE_KEY = 'language-crm'

export const LANGS = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  pt: 'Português',
  nl: 'Nederlands',
  ko: '한국어',
  ja: '日本語',
} satisfies Record<LanguageTypes, string>

export const LANGS_KEYS = Object.keys(LANGS) as LanguageTypes[]

export const LANGS_OPTIONS = getLanguageOptions(LANGS)
